import { DateTime } from "luxon";
import { UserNameRecoveryParamsDto } from "@api-types/user/UserNameRecoveryParamsDto";
import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";
import { ErrorResponse } from "@models/Models";

const loadFailPath = `/${getCurrentCulture()}/app-update`;
// prettier-ignore
const AgencyUserApiService = lazy(loadFailPath, ()=>import("@api-services/user/AgencyUserApiService"));
class ForgotUsernameService {
	async forgotUsername(model: ForgetUserNameFormData) {
		try {
			const newModel: UserNameRecoveryParamsDto = {
				dateOfBirth: DateTime.fromISO(model.dateOfBirth).toFormat(
					"MM-dd-yyyy"
				),
				email: model.email,
				challengeResponse: "",
			};

			await (
				await AgencyUserApiService
			).default.recoverUsername(newModel);

			return new Response();
		} catch (error) {
			if (error?.data?.statusCode == 500) {
				if (error?.data?.errorCode === 400158) {
					throw new ErrorResponse({
						message: "FORGOT_USERNAME_INVALID_USERNAME_DOB",
					});
				} else if (error?.data?.errorCode === 4030000000) {
					throw new ErrorResponse({
						message: "FORGOT_USERNAME_NOT_VERIFIED",
					});
				} else if (error?.data?.errorCode === 400161) {
					throw new ErrorResponse({
						message: "FORGOT_USERNAME_SHOP_ADDRESS",
						options: error?.data?.details,
					});
				}
			}

			throw new ErrorResponse({ message: "GENERIC_ERROR" });
		}
	}
}

export const forgotUsernameServiceInstance = new ForgotUsernameService();

export type ForgetUserNameFormData = {
	/** Time string */
	dateOfBirth: string;
	email: string;
};
